const dateFormat = 'YYYY-MM-DD';
export default dateFormat;
